var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLims({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3338 7H26.6672V24.7667L10.0005 47H50.0005L33.3338 24.7667V7Z",
    fill: "url(#paint0_linear_394_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3336 48.3333L40.0003 22.5667V8.66667L44.5003 3.03334C45.3669 1.93334 44.6003 0.333336 43.2003 0.333336H16.8003C15.4003 0.333336 14.6336 1.93334 15.5003 3.03334L20.0003 8.66667V22.5667L0.666926 48.3333C-0.966408 50.5333 0.600259 53.6667 3.33359 53.6667H56.6669C59.4003 53.6667 60.9669 50.5333 59.3336 48.3333ZM10.0003 47L26.6669 24.7667V7H33.3336V24.7667L50.0003 47H10.0003Z",
    fill: "url(#paint1_linear_394_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_394_16",
    x1: 10.0005,
    y1: 25.439,
    x2: 50.0005,
    y2: 25.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF986C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_394_16",
    x1: 0.00293016,
    y1: 24.9187,
    x2: 59.9976,
    y2: 24.9187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF986C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLims);
export default __webpack_public_path__ + "static/media/lims.6990a0fe11c7aa7e58b9344ef2932f8c.svg";
export { ForwardRef as ReactComponent };